export default __webpack_public_path__ + "static/media/review-24.09623b10.png";